import { createMuiTheme, colors } from '@material-ui/core';
import shadows from './shadows';
import typography from './typography';

const theme = createMuiTheme({
  palette: {
    background: {
      dark: '#F4F6F8',
      light: '#F1F5F7',
      default: colors.common.white,
      paper: colors.common.white
    },
    primary: {
      main: '#0080CC'
    },
    secondary: {
      main: '#666666'
    },
    text: {
      primary: '#333333',
      secondary: '#666666',
      main: '#0080CC'
    },
    active: {
      main: '#666666',
      selected: '#028BD2',
      background: '#E5ECF0'
    }
  },
  spacing: 10,
  shadows,
  typography
});

export default theme;
